'use strict';

exports.__esModule = true;

var _regenerator = require('babel-runtime/regenerator');

var _regenerator2 = _interopRequireDefault(_regenerator);

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

exports.default = patientsSaga;

var _webUtils = require('@vezeeta/web-utils');

var _effects = require('redux-saga/effects');

var _Constants = require('@vezeeta/enterprise-utils/lib/Constants');

var _webSso = require('@vezeeta/web-sso');

var _patients = require('../actions/patients');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _marked = /*#__PURE__*/_regenerator2.default.mark(sagaFetchPatients),
    _marked2 = /*#__PURE__*/_regenerator2.default.mark(sagaGetPatientDetails),
    _marked3 = /*#__PURE__*/_regenerator2.default.mark(sagaSearchPatients),
    _marked4 = /*#__PURE__*/_regenerator2.default.mark(sagaAddPatient),
    _marked5 = /*#__PURE__*/_regenerator2.default.mark(sagaEditPatientDetails),
    _marked6 = /*#__PURE__*/_regenerator2.default.mark(sagaEditPatient),
    _marked7 = /*#__PURE__*/_regenerator2.default.mark(sagaDeletePatient),
    _marked8 = /*#__PURE__*/_regenerator2.default.mark(sagafetchPatientListPaginated),
    _marked9 = /*#__PURE__*/_regenerator2.default.mark(sagafetchPatientInfo),
    _marked10 = /*#__PURE__*/_regenerator2.default.mark(patientsSaga);

function sagaFetchPatients(payload) {
  var fetchPatientsAPI, bodyReq, fetchPatientsResponse;
  return _regenerator2.default.wrap(function sagaFetchPatients$(_context) {
    while (1) {
      switch (_context.prev = _context.next) {
        case 0:
          fetchPatientsAPI = new _webSso.AuthApi();
          bodyReq = [{
            EntityKey: payload.entityKey,
            KeyWord: '',
            Page: 0,
            PageSize: _Constants.PAGE_SIZE
          }];
          _context.next = 4;
          return fetchPatientsAPI.post(_webUtils.Urls.searchPatientsByKeyword, bodyReq);

        case 4:
          fetchPatientsResponse = _context.sent;

          if (!_webUtils.STATUS.isSuccess(fetchPatientsResponse.status)) {
            _context.next = 10;
            break;
          }

          _context.next = 8;
          return (0, _effects.put)({
            type: _patients.PATIENTS.FETCH.SUCCESS,
            patients: fetchPatientsResponse.data[0].Model
          });

        case 8:
          _context.next = 12;
          break;

        case 10:
          _context.next = 12;
          return (0, _effects.put)({
            type: _patients.PATIENTS.FETCH.FAIL,
            error: fetchPatientsResponse
          });

        case 12:
        case 'end':
          return _context.stop();
      }
    }
  }, _marked, this);
}

function sagaGetPatientDetails(payload) {
  var getPatientDetailsAPI, body, getPatientDetailsResponse;
  return _regenerator2.default.wrap(function sagaGetPatientDetails$(_context2) {
    while (1) {
      switch (_context2.prev = _context2.next) {
        case 0:
          getPatientDetailsAPI = new _webSso.AuthApi();
          body = [payload.patientKey];
          _context2.next = 4;
          return getPatientDetailsAPI.post(_webUtils.Urls.getPatientByKeyUrl, body);

        case 4:
          getPatientDetailsResponse = _context2.sent;

          if (!_webUtils.STATUS.isSuccess(getPatientDetailsResponse.status)) {
            _context2.next = 10;
            break;
          }

          _context2.next = 8;
          return (0, _effects.put)({
            type: _patients.PATIENTS.GET_PATIENT_DETAILS.SUCCESS,
            patientDetails: getPatientDetailsResponse.data[0]
          });

        case 8:
          _context2.next = 12;
          break;

        case 10:
          _context2.next = 12;
          return (0, _effects.put)({
            type: _patients.PATIENTS.GET_PATIENT_DETAILS.FAIL,
            error: getPatientDetailsResponse
          });

        case 12:
        case 'end':
          return _context2.stop();
      }
    }
  }, _marked2, this);
}

function sagaSearchPatients(payload) {
  var searchPatientsAPI, body, searchPatientsResponse;
  return _regenerator2.default.wrap(function sagaSearchPatients$(_context3) {
    while (1) {
      switch (_context3.prev = _context3.next) {
        case 0:
          if (!payload.entitiesKeys) {
            _context3.next = 8;
            break;
          }

          searchPatientsAPI = new _webSso.AuthApi();
          body = payload.entitiesKeys.map(function (entityKey) {
            return {
              EntityKey: entityKey,
              KeyWord: payload.query,
              Page: 0,
              PageSize: _Constants.PAGE_SIZE
            };
          });
          _context3.next = 5;
          return searchPatientsAPI.post(_webUtils.Urls.searchPatientsByKeyword, body);

        case 5:
          searchPatientsResponse = _context3.sent;
          _context3.next = 8;
          return (0, _effects.put)({
            type: _patients.PATIENTS.SEARCH.SUCCESS,
            patients: payload.query === '' ? [] : searchPatientsResponse.data,
            source: payload.source
          });

        case 8:
        case 'end':
          return _context3.stop();
      }
    }
  }, _marked3, this);
}

function getBodyAddPatient(patient, entityKey) {
  var addPatientBody = [];
  addPatientBody.push({
    entityKey: entityKey,
    PatientModel: _extends({}, patient)
  });
  return addPatientBody;
}

function sagaAddPatient(payload) {
  var entityKey, bodyReq, addPatientAPI, addPatientResponse, patient;
  return _regenerator2.default.wrap(function sagaAddPatient$(_context4) {
    while (1) {
      switch (_context4.prev = _context4.next) {
        case 0:
          entityKey = payload.entityKey;
          bodyReq = getBodyAddPatient(payload.patient, entityKey);
          addPatientAPI = new _webSso.AuthApi();
          _context4.next = 5;
          return addPatientAPI.post(_webUtils.Urls.createPatient, bodyReq);

        case 5:
          addPatientResponse = _context4.sent;

          if (!_webUtils.STATUS.isSuccess(addPatientResponse.status)) {
            _context4.next = 12;
            break;
          }

          patient = _extends({}, payload.patient, {
            PatientKey: addPatientResponse.data[0]
            // insuranceName: payload.insurancesNames.get(payload.patient.insurance),
          });

          /* if (payload.callback) {
            payload.callback(...payload.callbackParams, patient);
          } */

          _context4.next = 10;
          return (0, _effects.put)({
            type: _patients.PATIENTS.ADD.SUCCESS,
            patient: patient
          });

        case 10:
          _context4.next = 14;
          break;

        case 12:
          _context4.next = 14;
          return (0, _effects.put)({
            type: _patients.PATIENTS.ADD.FAIL,
            error: addPatientResponse.response
          });

        case 14:
        case 'end':
          return _context4.stop();
      }
    }
  }, _marked4, this);
}

function sagaEditPatientDetails(payload) {
  var editPatientAPI, authToken, header, editPatientAPIResponse, patient;
  return _regenerator2.default.wrap(function sagaEditPatientDetails$(_context5) {
    while (1) {
      switch (_context5.prev = _context5.next) {
        case 0:
          editPatientAPI = new _webUtils.API();
          authToken = _webUtils.Cookie.get(_webUtils.Cookie.AUTH_TOKEN);
          header = [{
            key: 'x-vzt-authentication',
            value: '' + authToken
          }];
          _context5.next = 5;
          return editPatientAPI.post(_webUtils.Urls.editPatientDetails, _extends({}, payload.patient), header);

        case 5:
          editPatientAPIResponse = _context5.sent;

          if (!_webUtils.STATUS.isSuccess(editPatientAPIResponse.status)) {
            _context5.next = 12;
            break;
          }

          patient = _extends({}, payload.patient);
          _context5.next = 10;
          return (0, _effects.put)((0, _patients.editPatientDetailsSuccess)({
            type: _patients.PATIENTS.EDIT_PATIENT_DETAILS.SUCCESS,
            patient: patient
          }));

        case 10:
          _context5.next = 14;
          break;

        case 12:
          _context5.next = 14;
          return (0, _effects.put)((0, _patients.editPatientDetailsFail)({
            type: _patients.PATIENTS.EDIT_PATIENT_DETAILS.FAIL,
            error: editPatientAPIResponse.response
          }));

        case 14:
        case 'end':
          return _context5.stop();
      }
    }
  }, _marked5, this);
}

function sagaEditPatient(payload) {
  var bodyReq, editPatientAPI, editPatientResponse;
  return _regenerator2.default.wrap(function sagaEditPatient$(_context6) {
    while (1) {
      switch (_context6.prev = _context6.next) {
        case 0:
          bodyReq = _extends({}, payload.patient);
          editPatientAPI = new _webSso.AuthApi();
          _context6.next = 4;
          return editPatientAPI.post(_webUtils.Urls.editPatient, bodyReq);

        case 4:
          editPatientResponse = _context6.sent;

          if (!_webUtils.STATUS.isSuccess(editPatientResponse.status)) {
            _context6.next = 10;
            break;
          }

          _context6.next = 8;
          return (0, _effects.put)({
            type: _patients.PATIENTS.EDIT.SUCCESS,
            patient: payload.patient
          });

        case 8:
          _context6.next = 12;
          break;

        case 10:
          _context6.next = 12;
          return (0, _effects.put)({
            type: _patients.PATIENTS.EDIT.FAIL,
            error: editPatientResponse
          });

        case 12:
        case 'end':
          return _context6.stop();
      }
    }
  }, _marked6, this);
}

function sagaDeletePatient(payload) {
  var bodyReq, deletePatientAPI, deletePatientResponse;
  return _regenerator2.default.wrap(function sagaDeletePatient$(_context7) {
    while (1) {
      switch (_context7.prev = _context7.next) {
        case 0:
          bodyReq = [].concat(payload.patientKey);
          deletePatientAPI = new _webSso.AuthApi();
          _context7.next = 4;
          return deletePatientAPI.post(_webUtils.Urls.deletePatientByKeyUrl, bodyReq);

        case 4:
          deletePatientResponse = _context7.sent;

          if (!_webUtils.STATUS.isSuccess(deletePatientResponse.status)) {
            _context7.next = 10;
            break;
          }

          _context7.next = 8;
          return (0, _effects.put)({
            type: _patients.PATIENTS.DELETE.SUCCESS,
            patientKey: payload.patientKey
          });

        case 8:
          _context7.next = 12;
          break;

        case 10:
          _context7.next = 12;
          return (0, _effects.put)({
            type: _patients.PATIENTS.DELETE.FAIL,
            error: deletePatientResponse
          });

        case 12:
        case 'end':
          return _context7.stop();
      }
    }
  }, _marked7, this);
}

function sagafetchPatientListPaginated(action) {
  var patientsListAPI, authToken, header, response;
  return _regenerator2.default.wrap(function sagafetchPatientListPaginated$(_context8) {
    while (1) {
      switch (_context8.prev = _context8.next) {
        case 0:
          patientsListAPI = new _webUtils.API();
          authToken = _webUtils.Cookie.get(_webUtils.Cookie.AUTH_TOKEN);
          header = [{
            key: 'x-vzt-authentication',
            value: '' + authToken
          }];
          _context8.next = 5;
          return patientsListAPI.post(_webUtils.Urls.getPatientList, action.payload, header);

        case 5:
          response = _context8.sent;

          if (!_webUtils.STATUS.isSuccess(response.status)) {
            _context8.next = 11;
            break;
          }

          _context8.next = 9;
          return (0, _effects.put)((0, _patients.fetchPatientListSuccess)(_extends({}, response.data, action.payload)));

        case 9:
          _context8.next = 13;
          break;

        case 11:
          _context8.next = 13;
          return (0, _effects.put)((0, _patients.fetchPatientListFail)(_extends({}, action.payload)));

        case 13:
        case 'end':
          return _context8.stop();
      }
    }
  }, _marked8, this);
}

function sagafetchPatientInfo(action) {
  var patientInfoAPI, authToken, header, response;
  return _regenerator2.default.wrap(function sagafetchPatientInfo$(_context9) {
    while (1) {
      switch (_context9.prev = _context9.next) {
        case 0:
          patientInfoAPI = new _webUtils.API();
          authToken = _webUtils.Cookie.get(_webUtils.Cookie.AUTH_TOKEN);
          header = [{
            key: 'x-vzt-authentication',
            value: '' + authToken
          }];
          _context9.next = 5;
          return patientInfoAPI.get(_webUtils.Urls.getPatientInfo + '/' + (action.payload && action.payload.patientKey), header);

        case 5:
          response = _context9.sent;

          if (!_webUtils.STATUS.isSuccess(response.status)) {
            _context9.next = 11;
            break;
          }

          _context9.next = 9;
          return (0, _effects.put)((0, _patients.fetchPatientInfoSuccess)(_extends({}, response.data, action.payload)));

        case 9:
          _context9.next = 13;
          break;

        case 11:
          _context9.next = 13;
          return (0, _effects.put)((0, _patients.fetchPatientInfoFail)(_extends({}, action.payload)));

        case 13:
        case 'end':
          return _context9.stop();
      }
    }
  }, _marked9, this);
}

function patientsSaga() {
  return _regenerator2.default.wrap(function patientsSaga$(_context10) {
    while (1) {
      switch (_context10.prev = _context10.next) {
        case 0:
          _context10.next = 2;
          return (0, _effects.takeEvery)(_patients.PATIENTS.SEARCH.LOAD, sagaSearchPatients);

        case 2:
          _context10.next = 4;
          return (0, _effects.takeEvery)(_patients.PATIENTS.FETCH.LOAD, sagaFetchPatients);

        case 4:
          _context10.next = 6;
          return (0, _effects.takeEvery)(_patients.PATIENTS.GET_PATIENT_DETAILS.LOAD, sagaGetPatientDetails);

        case 6:
          _context10.next = 8;
          return (0, _effects.takeEvery)(_patients.PATIENTS.ADD.LOAD, sagaAddPatient);

        case 8:
          _context10.next = 10;
          return (0, _effects.takeEvery)(_patients.PATIENTS.EDIT_PATIENT_DETAILS.LOAD, sagaEditPatientDetails);

        case 10:
          _context10.next = 12;
          return (0, _effects.takeEvery)(_patients.PATIENTS.EDIT.LOAD, sagaEditPatient);

        case 12:
          _context10.next = 14;
          return (0, _effects.takeEvery)(_patients.PATIENTS.DELETE.LOAD, sagaDeletePatient);

        case 14:
          _context10.next = 16;
          return (0, _effects.takeEvery)(_patients.PATIENTS.PATIENT_LIST.FETCH, sagafetchPatientListPaginated);

        case 16:
          _context10.next = 18;
          return (0, _effects.takeEvery)(_patients.PATIENTS.GET_PATIENT_INFO.LOAD, sagafetchPatientInfo);

        case 18:
        case 'end':
          return _context10.stop();
      }
    }
  }, _marked10, this);
}
module.exports = exports['default'];